export default "__VITE_ASSET__e6d8c8eb__"